const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "copy_svg__dl"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.35,
    y: 112.83,
    width: 194.79,
    height: 250.82,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.35,
    y: 118.83,
    width: 182.79,
    height: 238.82,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "copy_svg__dr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m87.86,314.14h51.72v-24h-27.72V84.35h149.77v27h-109.77c-6.62,0-12,5.38-12,12v229.8c0,6.62,5.38,12,12,12h173.77c6.62,0,12-5.38,12-12V123.35c0-6.62-5.38-12-12-12h-40v-51H87.86v253.8Zm76,27v-205.8h149.77v205.8h-149.77Z",
    style: {
      fill: "#f7f7f7"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.47e208fa3cd75e52a19f3ea46dc5e5fc.svg";
export { ForwardRef as ReactComponent };